import { render, staticRenderFns } from "./CommonProblem.vue?vue&type=template&id=deb31e62&scoped=true&"
import script from "./CommonProblem.vue?vue&type=script&lang=js&"
export * from "./CommonProblem.vue?vue&type=script&lang=js&"
import style0 from "./CommonProblem.vue?vue&type=style&index=0&id=deb31e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb31e62",
  null
  
)

export default component.exports